// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import searchExamsSelector from '../../redux/selectors/searchExamsSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { ProductCard } from '../../components/NewCard/types';
import { KeywordTitle } from '../../redux/actionCreators/search/searchExamsKeywordActions';
import { SearchCondition } from '../../types/Model';

// 未來要改一下這個 Action，現在是用假 data 所以沒差
const {
  searchExamsActions,
  searchExamsKeywordActions
} = actionCreatorsList;

export function useSearchExams(limit: number, page: number, condition: SearchCondition): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(searchExamsActions.request({
      limit,
      page,
      condition
    }));
  }, [page, condition])
}

export function useSearchExamsKeywords(limit: number, name: string): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (name.length > 0) {
      dispatch(searchExamsKeywordActions.request({
        limit,
        name
      }));
    }
  }, [limit, name])
}

export function useIsFetching(): boolean {
  return useSelector(searchExamsSelector.makeIsFetching())
}

export function useExamsList(): ProductCard[] {
  return useSelector(searchExamsSelector.makeSearchExams());
}

export function useError(): Error | undefined {
  return useSelector(searchExamsSelector.makeError());
}

export function useKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchExamsSelector.makeSearchKeywordByKey(keyword));
}

export function useHasMoreResults(): boolean {
  return useSelector(searchExamsSelector.makeHasMore());
}

export function useIsMoreFetching(): boolean {
  return useSelector(searchExamsSelector.makeIsMoreFetching())
}

export function useCommonKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchExamsSelector.makeSearchCommonKeywordByKey(keyword))
}
